import React, {Fragment} from 'react';
import {useForm} from 'react-hook-form';
import $ from "jquery";
import '../css/responsive.css'

// let configFields={

//     businessPartner:{},

//     itemData:{

//         IDMD0:{id:"IDMD0",show:"true",edit:"true"},
//         IDMD1:{id:"IDMD1",show:"true",edit:"true"},
//         IDMD2:{id:"IDMD2",show:"true",edit:"true"},
//         IDMD3:{id:"IDMD3",show:"true",edit:"true"},
//         IDMD4:{id:"IDMD4",show:"true",edit:"true"},
//         IDMD5:{id:"IDMD5",show:"true",edit:"true"},
//         IDMD6:{id:"IDMD6",show:"true",edit:"true"},
//         IDMD7:{id:"IDMD7",show:"true",edit:"true"},

//         IDSD0:{id:"IDSD0",show:"true",edit:"true"},
//         IDSD1:{id:"IDSD1",show:"true",edit:"true"},
//         IDSD2:{id:"IDSD2",show:"true",edit:"true"},
//         IDSD3:{id:"IDSD3",show:"true",edit:"true"},
//         IDSD4:{id:"IDSD4",show:"true",edit:"true"},
                

//         IDPD0:{id:"IDPD0",show:"true",edit:"true"},
//         IDPD1:{id:"IDPD1",show:"true",edit:"true"},
//         IDPD2:{id:"IDPD2",show:"true",edit:"true"},
//         IDPD3:{id:"IDPD3",show:"true",edit:"true"},
//         // IDPD4:{id:"IDPD4",show:"true",edit:"true"},

//         IDIA0:{id:"IDIA0",show:"true",edit:"true"},
//         IDIA1:{id:"IDIA1",show:"true",edit:"true"},
//         // IDIA2:{id:"IDIA2",show:"true",edit:"true"},

//         IDDA0:{id:"IDDA0",show:"true",edit:"true"},
//         IDDA1:{id:"IDDA1",show:"true",edit:"true"},
//         // IDDA2:{id:"IDDA2",show:"true",edit:"true"},
//     }
// }

const defaultConfig={
    edit_IDDA0:true,
    edit_IDDA1:true,
    edit_IDDA2:true,

    edit_IDIA0:true,
    edit_IDIA1:true,
    edit_IDIA2:true,

    edit_IDPD0:true,
    edit_IDPD1:true,
    edit_IDPD2:true,
    edit_IDPD3:true,
    edit_IDPD4:true,

    edit_IDSD0:true,
    edit_IDSD1:true,
    edit_IDSD2:true,
    edit_IDSD3:true,
    edit_IDSD4:true,

    show_IDDA0:true,
    show_IDDA1:true,
    show_IDDA2:true,

    show_IDIA0:true,
    show_IDIA1:true,
    show_IDIA2:true,

    show_IDPD0:true,
    show_IDPD1:true,
    show_IDPD2:true,
    show_IDPD3:true,
    show_IDPD4:true,

    show_IDSD0:true,
    show_IDSD1:true,
    show_IDSD2:true,
    show_IDSD3:true,
    show_IDSD4:true,
}

const ItemDataFields = (props) => {
    const { adminUsersModel, refreshModel, configFields, editMode, action, showAlert} = props;
    
    let userConfig=  null;
    const {register, handleSubmit} = useForm({
        defaultValues:(userConfig?userConfig:defaultConfig)
    });

    const onSubmit= (data) => {
        for (const key in configFields.itemData) {
            if (Object.hasOwnProperty.call(configFields.itemData, key)) {
                const items = configFields.itemData[key];
                for (const key2 in data) {
                    if (Object.hasOwnProperty.call(data, key2)) {
                        const value = data[key2];
                        if(`show_${key}` === key2){
                            items.show = value
                        }else if(`edit_${key}` === key2){
                            items.edit = value
                        }
                    }
                }
            }
        }
        setConfigModules(configFields);
        localStorage.setItem('userConfigFielsDA', JSON.stringify(configFields.itemData));
        localStorage.setItem('userConfigFiels2',JSON.stringify(data));
        showAlert({ type: 'info', message: 'Se guardo la configuración de campos datos del artículo' });
    }
    function setConfigModules(itemData) {
        adminUsersModel.U_FMB_ConfigModules = itemData;
        refreshModel(adminUsersModel);
    }

    function DisableChecks(field){

        let element= document.getElementById(field);
        
        if (element!==null){
            if (editMode===false){
                $("#"+field).find("input").attr("disabled", "disabled");
                $("#"+field).find("a").addClass("disablehyper").click(function (e) {e.preventDefault(); });
                $("#"+field).find("input").addClass("disable");           
            }else{
                $("#"+field).find("input").removeAttr("disabled");
                $("#"+field).find("a").removeClass("disablehyper").unbind("click");
                $("#"+field).find("input").removeClass("disable");                    
            }
        }         
    }

    return (
        <Fragment>
            {action === 2 ?DisableChecks("checksDA"):""}
            {editMode===true || action === 1 ?
                <div className='text-right'>
                    <button className='btn  mt-4 sucursal' onClick={handleSubmit(onSubmit)} style={{backgroundColor: "rgb(233, 236, 239)", color: "rgb(73, 80, 87)", border: "1px solid rgb(206, 212, 218)"}}>GUARDAR DATOS DE ARTÍCULOS</button>
                </div>
                :""
            }
                {/*CAMPOS DE USUARIO*/}
                {/* <div className='row mt-5'>
                    <div className='col-6'>
                        <h5 className='mb-4'>Campos de Usuario</h5>
                        <form>
                            <table>
                                <thead>
                                    <tr>
                                        <th>eCommerce Visible</th>
                                        <th className='text-center'>Mostrar</th>
                                        <th className='text-center'>Editar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>eCommerce Etiquetas</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>eCommerce Imágenes</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>eCommerce Anexo</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>eCommerce Precio</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Artículos Promocion</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Articulo nuevo</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Articulo Remate</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Ecommerce menu categoria 1</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Ecommerce menu categoria 2</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Ecommerce menu categoria 3</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Ecommerce menu categoria 4</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Ecommerce menu categoria 5</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Clave SAT</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Unidad de medida SAT</td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div> */}
                <div className='row mt-5' id="checksDA">   
                    <div className="col-12 col-md-6">
                        <h5 className='mb-4'>Campos SAP</h5>
                        <form>
                            <div className="table-responsive">
                            <table className="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th className='text-center'>Mostrar</th>
                                        <th className='text-center'>Editar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* DATOS MAESTROS */}
                                    {/* <tr>
                                        <td>Articulo</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDMD0")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDMD0")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Descripción</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDMD1")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDMD1")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Nombre Extranjero</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDMD2")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDMD2")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Clase de articulo</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDMD3")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDMD3")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Grupo de artículos</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDMD4")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDMD4")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Lista de Precios</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDMD5")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDMD5")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Código de barras</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDMD6")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDMD6")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Precio Unitario</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDMD7")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDMD7")}/>
                                        </td>
                                    </tr> */}
                                    <tr>
                                        <td className='text-center'colSpan={3} style={{background: "#eabf28"}}><strong>Datos de venta</strong></td>
                                    </tr>
                                    <tr>
                                        <td>Nombre de unidad de medida de ventas</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDSD0")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDSD0")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Artículos por unidad de ventas</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDSD1")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDSD1")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Nombre de unidad de medida de embalaje</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDSD2")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDSD2")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Cantidad por paquete</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDSD3")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDSD3")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Comentarios:</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDSD4")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDSD4")}/>
                                        </td>
                                    </tr>
                                    
                                    <tr>
                                        <td className='text-center'colSpan={3} style={{background: "#eabf28"}}><strong>Datos de Compras</strong></td>
                                    </tr>
                                    <tr>
                                        <td>Nombre de unidad de medida de compras</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDPD0")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDPD0")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Artículos por unidad de compras</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDPD1")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDPD1")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Nombre de unidad de medida de embalaje</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDPD2")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDPD2")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Cantidad por paquete</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDPD3")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDPD3")}/>
                                        </td>
                                    </tr>
                                    
                                   
                                </tbody>
                            </table>
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6">
                        <form>
                        <div className="table-responsive">
                            <table className="table table-sm">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th className='text-center'>Mostrar</th>
                                        <th className='text-center'>Editar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='text-center'colSpan={3} style={{background: "#eabf28"}}><strong>Inventario</strong></td>
                                    </tr>
                                    <tr>
                                        <td>En stock</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDIA0")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDIA0")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Tabla</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDIA1")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDIA1")}/>
                                        </td>
                                    </tr>
                                   
                                    <tr>
                                        <td className='text-center'colSpan={3} style={{background: "#eabf28"}}><strong>Propiedades</strong></td>
                                    </tr>
                                    {/* <tr>
                                        <td>Check</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDDA0")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDDA0")}/>
                                        </td>
                                    </tr> */}
                                    <tr>
                                        <td>Tabla</td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("show_IDDA1")}/>
                                        </td>
                                        <td className='text-center'>
                                            <input type="checkbox" {...register("edit_IDDA1")}/>
                                        </td>
                                    </tr>
                                    
                                   
                                </tbody>
                            </table>
                            </div>
                        </form>
                    </div>
                    
                </div> 
        </Fragment>
    )
    
}
export default ItemDataFields;